import IAction from "../../models/IAction";
import BaseReducer from "../../utilities/BaseReducer";
import NuovoAppuntamentoFormModel from "../agenda/models/NuovoAppuntamentoFormModel";
import AgendaAction from "./AgendaAction";
import AppuntamentoModel from "./models/AppuntamentoModel";
import GetAppuntamentiModel from "./models/GetAppuntamentiModel";
import IAgendaState from "./models/IAgendaState";

export default class AgendaReducer extends BaseReducer<IAgendaState> {
    public readonly initialState: IAgendaState = {
        nuovoAppuntamentoForm: new NuovoAppuntamentoFormModel({}),
        nuovoAppuntamento: new AppuntamentoModel({}),
        appuntamenti: [],
    };

    public [AgendaAction.REQUEST_SIMULAZIONE_NUOVO_APPUNTAMENTO_FORM_SET_FINISHED](
        state: IAgendaState,
        action: IAction<NuovoAppuntamentoFormModel>
    ): IAgendaState {
        return {
            ...state,
            nuovoAppuntamentoForm: action.payload!,
        };
    }

    public [AgendaAction.REQUEST_SIMULAZIONE_RESET_NUOVO_APPUNTAMENTI_FINISHED](
        state: IAgendaState,
        action: IAction<any>
    ): IAgendaState {
        return {
            ...state,
            nuovoAppuntamentoForm: this.initialState.nuovoAppuntamentoForm,
        };
    }

    public [AgendaAction.REQUEST_SIMULAZIONE_SALVA_APPUNTAMENTO_FINISHED](
        state: IAgendaState,
        action: IAction<AppuntamentoModel>
    ): IAgendaState {
        return {
            ...state,
            nuovoAppuntamento: action.payload!,
        };
    }

    public [AgendaAction.REQUEST_SIMULAZIONE_UPDATE_APPUNTAMENTO_FINISHED](
        state: IAgendaState,
        action: IAction<AppuntamentoModel>
    ): IAgendaState {
        return {
            ...state,
            nuovoAppuntamento: action.payload!,
        };
    }

    public [AgendaAction.REQUEST_SIMULAZIONE_GET_APPUNTAMENTI_FINISHED](
        state: IAgendaState,
        action: IAction<GetAppuntamentiModel[]>
    ): IAgendaState {
        return {
            ...state,
            appuntamenti: action.payload!,
        };
    }
}
